import React, { useState } from 'react'
import { Translate } from 'react-localize-redux'
///Import react section
import { withRouter } from 'react-router-dom'

/** Material-UI imports section */
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import Avatar from '@material-ui/core/Avatar'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import NumberIcon from '@material-ui/icons/FormatListNumberedOutlined'
import { withStyles } from '@material-ui/core/styles'
/** Import component section */
import withauthenticatedLayout from '../layouts/withauthenticatedLayout'
import PartNumberSelector from '../common/PartNumberSelector'
import { showPlotsFromPartNumber } from '../../store/helpers/ShowPlotToPartNumber'
import { BACKGROUND_COLOR_GRAY } from '../../store/helpers/StatusColorConstants'
const SearchPartNumberIndex = (props) => {
	const { classes } = props
	const [partNumberSelected, setPartNumeberSelected] = useState(null)
	const onSelectedPartNumber = (partNumber) => {
		setPartNumeberSelected(partNumber)
	}
	return (
		<Card className={classes.card}>
			<CardHeader
				avatar={
					<Avatar aria-label='recipe'>
						<NumberIcon />
					</Avatar>
				}
				title={<Translate id='searchPartNumbers.title' />}
			/>
			<CardContent className={classes.cardContent}>
				<Grid container spacing={8}>
					<Grid item xs={12}>
						<Typography color='primary' variant='h6' align='center'>
							<Translate id='searchPartNumbers.searchByPartNumber' />
						</Typography>
					</Grid>
					<Grid item xs={10}>
						<PartNumberSelector
							onPartNumberSelected={(partNumber) => {
								onSelectedPartNumber(partNumber)
							}}
						/>
					</Grid>
					<Grid item xs={2}>
						<Button
							color='primary'
							fullWidth
							variant='contained'
							disabled={!partNumberSelected}
							onClick={() =>
								showPlotsFromPartNumber(
									partNumberSelected.drawingName + '.pdf',
									partNumberSelected.companyToken
								)
							}
						>
							<Translate id='searchPartNumbers.searchSAP' />
						</Button>
					</Grid>
				</Grid>
			</CardContent>
		</Card>
	)
}

const styles = (theme) => ({
	cardContent: {
		backgroundColor: BACKGROUND_COLOR_GRAY,
	},
	card: {
		height: '100%',
		padding: '10px',
	},
})
export default withauthenticatedLayout(withRouter(withStyles(styles, { withTheme: true })(SearchPartNumberIndex)))
